/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    this.abortController = null;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      this.cancelRequests();
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  cancelRequests() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  getSearchResults(searchTerm) {
    // Önceki istekleri iptal et
    this.cancelRequests();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag&section_id=predictive-search`, { signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const resultsMarkup = section.innerHTML;
        const hasProducts = section.querySelector('.side-panel-content--tab-panel');

        if (hasProducts) {
          this.predictiveSearchResults.classList.remove('loading');
          this.renderSearchResults(resultsMarkup);
        } else {
          this.fallbackSearch(searchTerm, true, signal);
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          this.predictiveSearchResults.classList.remove('loading');
        }
      });
  }

  fallbackSearch(searchTerm, retryWithPrefix, signal) {
    fetch(`/search?q=${encodeURIComponent(searchTerm)}&type=product&view=drawer`, { signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fallbackContent = doc.querySelector('#drawer-fallback-results');
        const hasProducts = fallbackContent && fallbackContent.querySelector('.product-cart-item, .side-panel-content--tab-panel');

        if (hasProducts) {
          this.predictiveSearchResults.classList.remove('loading');
          this.renderSearchResults(fallbackContent.innerHTML);
        } else if (retryWithPrefix && /^\d+$/.test(searchTerm)) {
          this.fallbackSearch('VLM' + searchTerm, false, signal);
        } else {
          this.predictiveSearchResults.classList.remove('loading');
          if (fallbackContent) {
            this.renderSearchResults(fallbackContent.innerHTML);
          }
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          this.predictiveSearchResults.classList.remove('loading');
        }
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});